/**
 * E-signing placement markers (measure-then-place, Regta ADR-0044).
 *
 * The PDF sent for signing is rendered twice: a throwaway "measurement"
 * pass prints a tiny `@RSIG|…` token at the bottom-left of every signature
 * line and place/date blank, the backend reads each token's coordinates
 * out of the PDF, and the clean pass goes to the signing provider with
 * fields placed at those coordinates. The token format here is
 * byte-identical to the legacy template lane's, so one parser serves both.
 */
export const SIGN_MEASURE_PREFIX = '@RSIG';
/** `@RSIG|<role>|<ordinal>|<signerIndex>|<field>|`. Role must be `[a-z_]+`. */
export function signMeasureToken(role, ordinal, signerIndex, field) {
    return `${SIGN_MEASURE_PREFIX}|${role}|${ordinal}|${signerIndex}|${field}|`;
}
/** The lookup key a measurement map is keyed by: `role:ordinal:signerIndex:field`. */
export function signMeasureKey(role, ordinal, signerIndex, field) {
    return `${role}:${ordinal}:${signerIndex}:${field}`;
}
const TOKEN_RE = /@RSIG\|([a-z_]+)\|(\d+)\|(\d+)\|(signature|place|date)\|/;
export function parseSignMeasureToken(s) {
    const m = TOKEN_RE.exec(s);
    if (!m)
        return null;
    const role = m[1];
    const ordinal = Number(m[2]);
    const signerOrdinal = Number(m[3]);
    const field = m[4];
    return { role, ordinal, signerOrdinal, field, key: signMeasureKey(role, ordinal, signerOrdinal, field) };
}
/** `""` for a single signer (keeps captions stable), `" (n)"` (1-based) otherwise. */
export function signerDiscriminator(signerIndex, signerCount) {
    return signerCount <= 1 ? '' : ` (${signerIndex + 1})`;
}
export const SIGNING_ROW_LABELS = {
    signature: 'Underskrift',
    name: 'Namnförtydligande',
    place: 'Ort',
    date: 'Datum',
    legalId: 'Personnummer',
};
/** "Underskrift — Hyresvärden (2)": the caption under a signature line. */
export const signatureCaption = (label, signerIndex = 0, signerCount = 1) => `${SIGNING_ROW_LABELS.signature} — ${label}${signerDiscriminator(signerIndex, signerCount)}`;
//# sourceMappingURL=signing.js.map